/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-29 07:46:53
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import queryString from 'query-string';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Page, Layout, Card, TextField, Pagination, Icon } from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import { reduxForm, FieldArray, reset, getFormValues, change } from 'redux-form';

import NoProductRanking from 'src/components/views/product-ranking/no-product-ranking';
import DidYouKnow from 'src/components/views/product-ranking/did-you-know';
import TryNewVersion from 'src/components/containers/common/switchNewVersion/merchandising/try-new-version.jsx';
import ProductRankingList from 'src/components/views/product-ranking';
import ActionsGroup from 'src/components/views/product-ranking/actions-group';
import InvalidInputBanner from 'src/components/views/product-ranking/invalid-input-banner';
import MainMenu from 'src/components/containers/main-menu';
import TypeFormEmbedded from 'src/components/views/common/typeform-embedded';
import ExceededPlanNotification from 'src/components/containers/common/exceeded-plan-notifications';
import YoutubeModal from 'src/components/views/common/youtube-modal';
import RouteLeavingGuard from 'src/components/views/common/handle-leave/route-leaving-guard';
import ConfirmLeaveModal from 'src/components/views/common/handle-leave/confirm-leave-modal';

import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import { searchify } from 'src/helpers';
import { NUMBER_PRODUCT_RANKING_PER_PAGE } from 'src/constants/product-ranking';
import { APP_LANGUAGE_ENGLISH_VALUE } from 'src/constants/language-setting';
import { confirmLeavePage } from 'src/helpers';
import {
  buildProductRanking,
  buildInitialProductRanking,
  checkValidateProductRanking
} from 'src/helpers/product-ranking-helper';
import * as commonActions from 'actions/common-actions';
import * as merchandisingV2Actions from 'src/stores/actions/merchandising-v2-actions';
import * as productRankingActions from 'src/stores/actions/product-ranking-actions';
import * as checklistActions from 'actions/dashboard/checklist-actions';
import { updateTenantApp } from 'actions/oauth-actions';
import TitleHelp from 'src/components/views/common/title-help';

import type { ComposedProps, State } from './index.type';
class ProductRanking extends Component<ComposedProps, State> {
  timerTyping = undefined;
  state = {
    // Search string
    inputSearchText: '',

    // Show/Hide remove modal
    activeRemoveModal: false,

    skip: 0,
    limit: NUMBER_PRODUCT_RANKING_PER_PAGE,

    sortId: 'title',
    isAsc: false,
    hasPrevious: false,
    hasNext: false,

    // Show/Hide error banner
    dismissedBanner: true,
    messageError: '',

    actionSurvey: false,
    youtubeModal: false,

    // Show/Hide confirm reload list when searching/changing page/sorting
    activeModalConfirm: false,
    actionToGo: (params = {}) => {},
    params: {}
  };

  async componentDidMount() {
    // Get list of productRanking for selected page
    const queries = queryString.parse(this.props.location.search);
    let {
      q = '',
      skip = 0,
      limit = NUMBER_PRODUCT_RANKING_PER_PAGE,
      sortId = 'type',
      isAsc = false
    } = queries;
    skip = parseInt(skip);
    limit = parseInt(limit);

    this.setState({ skip, limit, inputSearchText: q, sortId, isAsc });
    this.props.getProductRanking(q, skip, limit, sortId, isAsc);

    // Handle when reload or leave page
    window.addEventListener('beforeunload', this.confirmLeavePage);
  }

  componentWillUnmount() {
    // Handle when reload or leave page
    window.removeEventListener('beforeunload', this.confirmLeavePage);
  }

  componentWillReceiveProps(nextProps) {
    const { skip, limit } = this.state;
    const { total, migrateStatus, getStatusMigrate } = nextProps;

    if (migrateStatus === 'running') {
      clearTimeout(this.timeOutGetStatus);
      this.timeOutGetStatus = setTimeout(() => {
        getStatusMigrate();
      }, 3000);
    }
    const hasNext = skip + limit < total;
    const hasPrevious = skip > 0;

    let updatedState = { hasNext, hasPrevious };

    this.setState(updatedState);
  }

  render() {
    const {
      dirty,
      handleSubmit,
      pristine,
      submitting,
      saving,
      formValues,
      updateProductRankingField,
      loading,
      saveSuccess,
      selectedPlan,
      appLanguage,
      history,
      getStatusMigrate,
      migrateNewFeatureV2,
      migrateStatus,
      updateTenantAppLoading,
      i18n
    } = this.props;
    const {
      skip,
      limit,
      sortId,
      isAsc,
      dismissedBanner,
      messageError,
      hasPrevious,
      hasNext,
      inputSearchText,
      actionSurvey,
      youtubeModal,
      activeModalConfirm
    } = this.state;

    const emptyProductRanking = formValues ? _.isEmpty(formValues['productRanking']) : true;

    return (
      <div className="BC-Page BC-Page__ProductRanking">
        <MainMenu menuId="menu-merchandising-product-ranking" />
        <Page
          title={i18n.translate('AdminHTML.ProductRanking.ProductRanking.pageTitle')}
          primaryAction={
            <div className="BC-Page BC-Page__Button">
              <ActionsGroup
                handleSubmit={handleSubmit(this.handleSave.bind(this))}
                handleCancel={this.discardChange}
                pristine={pristine}
                submitting={submitting}
                saving={saving}
                emptyProductRanking={emptyProductRanking}
                // PFSN-30966 Hide switch merchandising
                showButtonSwitchNew={false}
                onSwitchNew={this.onSwitchNew}
                loading={updateTenantAppLoading}
              />
            </div>
          }>
          <TitleHelp
            i18n={i18n}
            onPlay={() => this.toggleModal('youtubeModal')}
            hrefUserManual={URL['Link_V2_Merchandising_ProductRanking_ManualGuide']}
          />
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                {/* WARN: PFSN-30966 Hide switch merchandising - comment for hide - enable later*/}
                {/* Try new version */}
                {/* // New feature0423: old customer flow */}

                <TryNewVersion
                  migrateNewFeatureV2={migrateNewFeatureV2}
                  getStatusMigrate={getStatusMigrate}
                  migrateStatus={migrateStatus}
                  enableMerchandisingV2={this.enableMerchandisingV2}
                />
                {/* Did you know? */}
                <DidYouKnow />

                {/* Sticky notification for exceeded plan */}
                <ExceededPlanNotification />

                {/* Banner error */}
                {!dismissedBanner && (
                  <InvalidInputBanner onDismiss={this.handleDismissBanner} message={messageError} />
                )}
              </div>
            </Layout.Section>
            <Layout.Section>
              <Card sectioned>
                <Card.Header>
                  <div className="search" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp}>
                    <TextField
                      onChange={this.onSearchProductRanking}
                      value={inputSearchText}
                      prefix={<Icon source={SearchMinor} color="base" />}
                      placeholder={i18n.translate(
                        'AdminHTML.ProductRanking.ProductRanking.textField_Placeholder'
                      )}
                    />
                  </div>
                </Card.Header>
                <Card.Section>
                  {/* List of product ranking */}
                  <form onSubmit={this.handleDefaultSubmit} className="productRanking">
                    <FieldArray
                      name="productRanking"
                      component={ProductRankingList}
                      skip={skip}
                      limit={limit}
                      sortId={sortId}
                      isAsc={isAsc}
                      productRanking={formValues ? formValues['productRanking'] : []}
                      onSortProductRanking={(sortId, isAsc) =>
                        this.confirmLeave('sort', { sortId, isAsc })
                      }
                      updateProductRankingField={updateProductRankingField}
                      loading={loading}
                      appLanguage={appLanguage}
                    />
                  </form>
                  {emptyProductRanking && !loading && <NoProductRanking />}
                </Card.Section>
              </Card>

              {/* Pagination*/}
              <div className="pagination">
                {(hasPrevious || hasNext) && (
                  <Pagination
                    hasPrevious={hasPrevious}
                    onPrevious={() => this.confirmLeave('previousPage')}
                    hasNext={hasNext}
                    onNext={() => this.confirmLeave('nextPage')}
                  />
                )}

                <div className="actionsGroup">
                  <ActionsGroup
                    handleSubmit={handleSubmit(this.handleSave.bind(this))}
                    handleCancel={this.discardChange}
                    pristine={pristine}
                    submitting={submitting}
                    saving={saving}
                    emptyProductRanking={emptyProductRanking}
                  />
                </div>
              </div>
            </Layout.Section>
          </Layout>
        </Page>
        <YoutubeModal
          active={youtubeModal}
          embeddedURL={URL['Link_V2_Merchandising_ProductRanking_Video']}
          onClose={() => this.toggleModal('youtubeModal')}
          title={i18n.translate('AdminHTML.ProductRanking.ProductRanking.youtubeModal_Title')}
        />

        {!_.isEmpty(selectedPlan) && (
          <TypeFormEmbedded
            type="product-ranking"
            conditionShow={saveSuccess}
            conditionShowStateChange={actionSurvey}
          />
        )}

        {/* Confirm before leaving */}
        <RouteLeavingGuard
          when={dirty}
          // Navigate function
          navigate={path => history.push(path)}
          shouldBlockNavigation={dirty}
        />
        <ConfirmLeaveModal
          active={activeModalConfirm}
          handleCancel={this.closeModal}
          handleDiscard={this.handleDiscard}
        />
      </div>
    );
  }

  // Key press event on search field
  handleKeyDown = event => {
    clearTimeout(this.timerTyping);
  };

  // Key up event, start searching after 500ms
  handleKeyUp = event => {
    const charList = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const key = event.key.toLowerCase();
    const keyCode = event.keyCode;

    if (charList.indexOf(key) === -1 && keyCode !== 8) {
      return;
    }

    // Invoke search request after 500ms
    this.timerTyping = setTimeout(() => {
      this.confirmLeave('search');
    }, 500);
  };

  // On search text change
  onSearchProductRanking = inputSearchText => {
    this.setState({ inputSearchText });
  };

  // Search ranking
  handleSearch = () => {
    let inputSearchText = this.state.inputSearchText.toLowerCase().trim();
    const { sortId, isAsc } = this.state;
    inputSearchText = searchify(inputSearchText);

    // Having search text, search custom filter for page 1
    if (inputSearchText) {
      // Set limit per page
      this.setState({ skip: 0, limit: NUMBER_PRODUCT_RANKING_PER_PAGE });

      this.props.getProductRanking(
        inputSearchText,
        0,
        NUMBER_PRODUCT_RANKING_PER_PAGE,
        sortId,
        isAsc
      );
    } else {
      // Search text is empty, get all filter tree for page 1
      const skip = 0,
        limit = NUMBER_PRODUCT_RANKING_PER_PAGE;

      // Set skip, limit for page 1
      this.setState({ skip, limit });

      // Get filter trees
      this.props.getProductRanking('', skip, limit, sortId, isAsc);
    }
  };

  // Go to previous page
  getPreviousPage = () => {
    const { skip, limit, sortId, isAsc } = this.state;
    let { inputSearchText } = this.state;
    const previousSkip = skip - limit;
    const previousLimit = NUMBER_PRODUCT_RANKING_PER_PAGE;

    // Prevent multiple click that the skip number is less than 0
    if (previousSkip < 0) return;

    // Searchify input search
    inputSearchText = inputSearchText.toLowerCase().trim();
    inputSearchText = searchify(inputSearchText);

    // Set skip, limit for next page
    this.setState({ skip: previousSkip, limit: previousLimit });
    this.props.getProductRanking(inputSearchText || '', previousSkip, previousLimit, sortId, isAsc);
  };

  // Go to next page
  getNextPage = () => {
    const { skip, limit, sortId, isAsc } = this.state;
    let { inputSearchText } = this.state;
    const { total } = this.props;
    const nextSkip = skip + limit;

    // Prevent multiple click that the skip number is bigger than total
    if (nextSkip >= total) return;

    // Searchify input search
    inputSearchText = inputSearchText.toLowerCase().trim();
    inputSearchText = searchify(inputSearchText);

    // Set skip, limit for next page and disable flag for first page loading, don't need to display skeleton loading
    this.setState({ skip: nextSkip, limit });
    this.props.getProductRanking(
      inputSearchText || '',
      nextSkip,
      NUMBER_PRODUCT_RANKING_PER_PAGE,
      sortId,
      isAsc
    );
  };

  onSortProductRanking = params => {
    const { sortId, isAsc } = params;
    let { limit, inputSearchText } = this.state;

    // Searchify input search
    inputSearchText = inputSearchText.toLowerCase().trim();
    inputSearchText = searchify(inputSearchText);

    // Set sort id, asc
    this.setState({ sortId, isAsc, skip: 0 });
    this.props.getProductRanking(inputSearchText || '', 0, limit, sortId, isAsc);
  };

  // Save productRanking
  handleDefaultSubmit = e => {
    e.preventDefault();
  };

  // Save product ranking
  async handleSave(data) {
    const { i18n } = this.props;
    const { productRanking = [] } = data;

    const validateProductRankingResult = checkValidateProductRanking(productRanking, i18n);

    if (!_.isEmpty(validateProductRankingResult)) {
      this.setState({ dismissedBanner: false, messageError: validateProductRankingResult });
      return;
    }

    this.setState({ dismissedBanner: true, messageError: '' });

    // Save updated product ranking
    // Build product ranking data before saving
    const updatedProductRanking = buildProductRanking(productRanking);

    await this.props.updateProductRanking(updatedProductRanking);
    await this.props.getChecklist();
  }

  // Handle hide banner
  handleDismissBanner = () => {
    // Hide banner
    this.setState({ dismissedBanner: true, messageError: false });
  };

  // Discard
  discardChange = () => {
    const { resetForm } = this.props;
    const { actionSurvey } = this.state;

    // Reset form
    resetForm();
    this.setState({ actionSurvey: !actionSurvey });
  };

  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  // Handle confirm leave page
  confirmLeavePage = event => {
    const { dirty, i18n } = this.props;
    return confirmLeavePage(event, dirty, i18n);
  };

  // Handle confirm leave modal
  // Close modal
  closeModal = () => {
    this.setState({ activeModalConfirm: false, actionToGo: () => {}, params: {} });
  };

  // Handle confirm leave modal
  // Discard change, continue action
  handleDiscard = () => {
    const { params, actionToGo } = this.state;

    // Reset form
    this.discardChange();

    // Continue action
    if (!_.isEmpty(params)) {
      actionToGo(params);
    } else {
      actionToGo();
    }

    // Close modal
    this.closeModal();
  };

  // Handle confirm leave
  confirmLeave = (action, params = {}) => {
    const { dirty } = this.props;
    let callBack = (params = {}) => {};
    switch (action) {
      case 'sort': {
        callBack = this.onSortProductRanking;
        break;
      }
      case 'search': {
        callBack = this.handleSearch;
        break;
      }
      case 'nextPage': {
        callBack = this.getNextPage;
        break;
      }
      case 'previousPage': {
        callBack = this.getPreviousPage;
        break;
      }
      default:
    }
    if (dirty) {
      this.setState({ activeModalConfirm: true, actionToGo: callBack, params: params });
    } else {
      // $FlowFixMe
      callBack(params);
    }
  };

  // Action go to new version
  onSwitchNew = () => {
    const { updateTenantApp, history } = this.props;
    this.props.isOpenNewVersion(true);

    const body = { 'adminAppFeatures.merchandisingV2': true };

    const meta = {
      onSuccess: () => {
        history.push(routes.merchandising.view());
      }
    };
    updateTenantApp(body, meta);
  };

  enableMerchandisingV2 = value => {
    const { enableMerchandisingV2, history } = this.props;

    enableMerchandisingV2(value);
    history.push(routes.merchandising.view());
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  migrateNewFeatureV2: () => dispatch(commonActions.migrateNewFeatureV2(ownProps.i18n)),
  getStatusMigrate: () => dispatch(commonActions.getStatusMigrate(ownProps.i18n)),
  enableMerchandisingV2: enable =>
    dispatch(merchandisingV2Actions.enableMerchandisingV2(enable, ownProps.i18n)),
  getProductRanking: (q, skip, limit, sortId, isAsc) =>
    dispatch(productRankingActions.getProductRanking(q, skip, limit, sortId, isAsc, ownProps.i18n)),
  updateProductRanking: productRanking =>
    dispatch(productRankingActions.updateProductRanking(productRanking, ownProps.i18n)),
  resetForm: () => dispatch(reset('ProductRankingForm')),
  updateProductRankingField: (index, name, value) =>
    dispatch(change('ProductRankingForm', `productRanking[${index}][${name}]`, value)),
  getChecklist: () => dispatch(checklistActions.getChecklist(ownProps.i18n)),
  updateTenantApp: (body, meta) => dispatch(updateTenantApp(body, meta, ownProps.i18n)),
  isOpenNewVersion: value => dispatch(merchandisingV2Actions.isOpenNewVersion(value))
});

const mapStateToProps = (state, props) => {
  const productRanking = _.get(state.productRanking, 'productRanking', []);
  const formValues = getFormValues('ProductRankingForm')(state);
  const tenantId = _.get(state.oauth, 'tenantApp.tenantId', '');

  return {
    tenantId,
    migrateStatus: _.get(state.common, 'status', null),
    list: _.get(state.productRanking, 'productRanking', []),
    total: _.get(state.productRanking, 'total', 0),
    loading: _.get(state.productRanking, 'loading', false),
    saving: _.get(state.productRanking, 'saving', false),
    saveSuccess: _.get(state.productRanking, 'saveSuccess', false),
    productRanking,
    initialValues: buildInitialProductRanking(productRanking),
    formValues,
    selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan'),
    appLanguage: _.get(state.oauth.tenantApp, 'appLanguage', APP_LANGUAGE_ENGLISH_VALUE),
    updateTenantAppLoading: _.get(state.oauth, 'loadingUpdate', false)
  };
};

const ProductRankingForm = reduxForm({
  form: 'ProductRankingForm', // a unique identifier for this form
  enableReinitialize: true
})(ProductRanking);

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ProductRankingForm));
